import {
  COUNTRY_PHONES_CONFIG,
  GT,
  GT_CENTER,
  PA,
  PA_CENTER,
  SV,
  SV_CENTER,
} from '../constants/countryConstants';
import { PhoneCountryConfig } from '../models/countryModel';

export const getPhoneConfig = (
  countryCode: string,
): PhoneCountryConfig | undefined => {
  return COUNTRY_PHONES_CONFIG.find((pConfig) => pConfig.code === countryCode);
};

export const getCenterByCountryCode = (
  countryCode: string,
): { lat: number; lng: number } => {
  switch (countryCode) {
    case SV:
      return SV_CENTER;
    case GT:
      return GT_CENTER;
    case PA:
      return PA_CENTER;
    default:
      return SV_CENTER;
  }
};
